import { render, staticRenderFns } from "./details.position.component.vue?vue&type=template&id=2f8984c4"
import script from "./details.position.component.vue?vue&type=script&lang=js"
export * from "./details.position.component.vue?vue&type=script&lang=js"
import style0 from "./details.position.component.vue?vue&type=style&index=0&id=2f8984c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports